/**
 * @generated SignedSource<<a6557c795a4fbdbc9e9f0a0517eb2de2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddBundleAction = "add" | "delete" | "keep" | "modify";
export type AddBundleAutoRenew = "GR" | "OFF" | "ON";
export type AddBundleSystemAction = "ADDED" | "CANCEL" | "NONE" | "RESUME" | "TERMINATE" | "UPDATE";
export type AvailabilityStatus = "ACTIVE" | "AVAILABLE" | "CONGESTED" | "DUCTED_TO_PREMISE" | "ERROR" | "FIBRE_IN_A_DAY" | "FUTURE" | "INTACT" | "NOT_PLANNED" | "PLANNED" | "READY" | "UNAVAILABLE" | "UNDEFINED" | "UNDER_BUILD" | "UNKNOWN";
export type BalanceManagement = "POSTPAID" | "PREPAID";
export type BillingFrequency = "EVERY_28_DAYS" | "MONTHLY" | "ONE_OFF" | "ONE_OFF_TOTAL" | "ORIGINAL_RRP" | "UP_FRONT";
export type CartChannel = "businessshop" | "personalshop" | "personalss" | "sparkdigitalshop";
export type CartItemAction = "add" | "delete" | "keep" | "modify";
export type ContractTermUnit = "Day" | "Hour" | "Month" | "Week" | "Year";
export type FrequencyType = "NetRecurring" | "OneOff" | "OneOffTotal" | "OriginalRRP" | "Recurring" | "Upfront";
export type ProcessContext = "ADD_VAS" | "BUY_ONE_NUMBER" | "CHANGE_OFFER" | "MANAGE_VAS" | "MOBILE_MIGRATE" | "MODIFY_OFFER" | "NEW_OFFER" | "NONE";
export type AddBundlesInput = {
  agentDetails?: AgentDetailsRequest | null;
  bundles: ReadonlyArray<AddBundlesInputBundle>;
  cartId?: string | null;
  channel: CartChannel;
  processContext?: ProcessContext | null;
};
export type AgentDetailsRequest = {
  channelName: string;
  dealerCode: string;
  salesAgentId: string;
};
export type AddBundlesInputBundle = {
  accountNumber?: string | null;
  categoryId?: string | null;
  items: ReadonlyArray<AddBundlesInputItem>;
  lineNumber?: string | null;
};
export type AddBundlesInputItem = {
  action?: AddBundleAction | null;
  agentDetails?: AgentDetailsRequest | null;
  associatedProductOfferingId?: string | null;
  offerId: string;
  productCharacteristics?: ProductCharacteristicsInput | null;
  productInstanceId?: string | null;
  quantity?: number | null;
};
export type ProductCharacteristicsInput = {
  autoRenew?: AddBundleAutoRenew | null;
  systemAction?: AddBundleSystemAction | null;
};
export type useAddToCartMutation$variables = {
  input: AddBundlesInput;
  channel: CartChannel;
};
export type useAddToCartMutation$data = {
  readonly addBundles: {
    readonly cart: {
      readonly cartId: string;
      readonly accountNumber: string | null;
      readonly isAccountNumberRequired: boolean;
      readonly segment: string | null;
      readonly shippableItems: ReadonlyArray<{
        readonly offerId: string;
        readonly categories: ReadonlyArray<string>;
      }> | null;
      readonly bundles: ReadonlyArray<{
        readonly lineNumber: string | null;
        readonly isLineNumberRequired: boolean | null;
        readonly bundleId: string;
        readonly bundleType: string | null;
        readonly bundleSubType: string | null;
        readonly processContext: ProcessContext;
        readonly categoryId: string | null;
        readonly promotion: boolean | null;
        readonly offerIds: ReadonlyArray<string>;
        readonly availability: {
          readonly available: boolean;
          readonly offerCategory: string;
          readonly status: AvailabilityStatus;
        } | null;
        readonly items: ReadonlyArray<{
          readonly action: CartItemAction | null;
          readonly itemId: string;
          readonly productOfferingId: string;
          readonly title: string;
          readonly creditItemDescriptions: ReadonlyArray<string> | null;
          readonly description: string | null;
          readonly priceItemName: string | null;
          readonly priceItemDescriptions: ReadonlyArray<string> | null;
          readonly quantity: number;
          readonly removable: boolean | null;
          readonly editable: boolean | null;
          readonly dealText: string;
          readonly imageUrl: string | null;
          readonly totalPrice: number | null;
          readonly balanceManagement: BalanceManagement | null;
          readonly contractTerm: {
            readonly name: string | null;
            readonly value: number;
            readonly unit: ContractTermUnit;
            readonly ifpOfferId: string | null;
          } | null;
          readonly preOrderable: boolean | null;
          readonly prices: ReadonlyArray<{
            readonly billingFrequency: BillingFrequency | null;
            readonly frequencyType: FrequencyType | null;
            readonly basePrice: {
              readonly value: number;
              readonly taxExclusiveValue: number;
            } | null;
            readonly effectivePrice: {
              readonly value: number;
              readonly taxExclusiveValue: number;
            } | null;
            readonly discount: {
              readonly discountId: string | null;
              readonly type: string | null;
              readonly value: number;
              readonly discountType: string;
              readonly taxExclusiveValue: number;
              readonly discountText: string;
              readonly discountAppliedValue: number;
            } | null;
          }> | null;
          readonly offerId: string;
          readonly categories: ReadonlyArray<string>;
          readonly dataLayerCategory: string | null;
          readonly isIncluded: boolean | null;
          readonly shouldHide: boolean | null;
          readonly promotion: boolean | null;
        }> | null;
      }> | null;
      readonly auth: {
        readonly isAuthenticated: boolean;
        readonly isGuest: boolean;
      };
      readonly summaries: ReadonlyArray<{
        readonly billingFrequency: BillingFrequency | null;
        readonly frequencyType: FrequencyType;
        readonly subtotal: number;
        readonly total: number;
        readonly taxExclusiveSubtotal: number;
        readonly discount: number | null;
        readonly taxExclusiveDiscount: number | null;
        readonly taxExclusiveTotal: number;
        readonly gst: number;
      }> | null;
      readonly mpdDiscountPercentage: number | null;
      readonly productOfferImages: ReadonlyArray<{
        readonly offerId: string;
        readonly url: string | null;
        readonly type: string | null;
      }> | null;
    } | null;
    readonly isAddonsJourneyEligible: boolean;
    readonly isGiftWithPurchaseJourneyEligible: boolean | null;
    readonly affectedBundle: {
      readonly bundleId: string;
      readonly items: ReadonlyArray<{
        readonly itemId: string;
        readonly promotion: boolean | null;
      }> | null;
    } | null;
  };
};
export type useAddToCartMutation = {
  variables: useAddToCartMutation$variables;
  response: useAddToCartMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "channel"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cartId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountNumber",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAccountNumberRequired",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "segment",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offerId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categories",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Item",
  "kind": "LinkedField",
  "name": "shippableItems",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bundleId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "promotion",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itemId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billingFrequency",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "frequencyType",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taxExclusiveValue",
  "storageKey": null
},
v17 = [
  (v13/*: any*/),
  (v16/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Bundle",
  "kind": "LinkedField",
  "name": "bundles",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lineNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLineNumberRequired",
      "storageKey": null
    },
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bundleType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bundleSubType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "processContext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "categoryId",
      "storageKey": null
    },
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offerIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Availability",
      "kind": "LinkedField",
      "name": "availability",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "available",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "offerCategory",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "action",
          "storageKey": null
        },
        (v12/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productOfferingId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creditItemDescriptions",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priceItemName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priceItemDescriptions",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quantity",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "removable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "editable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dealText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalPrice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "balanceManagement",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ContractTerm",
          "kind": "LinkedField",
          "name": "contractTerm",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            (v13/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "unit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ifpOfferId",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "preOrderable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CartPriceFull",
          "kind": "LinkedField",
          "name": "prices",
          "plural": true,
          "selections": [
            (v14/*: any*/),
            (v15/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "CartPrice",
              "kind": "LinkedField",
              "name": "basePrice",
              "plural": false,
              "selections": (v17/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CartPrice",
              "kind": "LinkedField",
              "name": "effectivePrice",
              "plural": false,
              "selections": (v17/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CartDiscount",
              "kind": "LinkedField",
              "name": "discount",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "discountId",
                  "storageKey": null
                },
                (v18/*: any*/),
                (v13/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "discountType",
                  "storageKey": null
                },
                (v16/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "discountText",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "discountAppliedValue",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v7/*: any*/),
        (v8/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dataLayerCategory",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isIncluded",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shouldHide",
          "storageKey": null
        },
        (v11/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Auth",
  "kind": "LinkedField",
  "name": "auth",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuthenticated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGuest",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Summary",
  "kind": "LinkedField",
  "name": "summaries",
  "plural": true,
  "selections": [
    (v14/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtotal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taxExclusiveSubtotal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "discount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taxExclusiveDiscount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taxExclusiveTotal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gst",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mpdDiscountPercentage",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "channel",
      "variableName": "channel"
    }
  ],
  "concreteType": "ProductOfferImage",
  "kind": "LinkedField",
  "name": "productOfferImages",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    (v18/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": (v2/*: any*/),
  "kind": "ScalarField",
  "name": "isAddonsJourneyEligible",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": (v2/*: any*/),
  "kind": "ScalarField",
  "name": "isGiftWithPurchaseJourneyEligible",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Bundle",
  "kind": "LinkedField",
  "name": "affectedBundle",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v12/*: any*/),
        (v11/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useAddToCartMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AddBundleOperationResponse",
        "kind": "LinkedField",
        "name": "addBundles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Cart",
            "kind": "LinkedField",
            "name": "cart",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v9/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/)
            ],
            "storageKey": null
          },
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useAddToCartMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AddBundleOperationResponse",
        "kind": "LinkedField",
        "name": "addBundles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Cart",
            "kind": "LinkedField",
            "name": "cart",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v9/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e00d882423b5b02eaf22691aafda9870",
    "id": null,
    "metadata": {},
    "name": "useAddToCartMutation",
    "operationKind": "mutation",
    "text": "mutation useAddToCartMutation(\n  $input: AddBundlesInput!\n  $channel: CartChannel!\n) {\n  addBundles(input: $input) {\n    cart {\n      cartId\n      accountNumber\n      isAccountNumberRequired\n      segment\n      shippableItems {\n        offerId\n        categories\n      }\n      bundles {\n        lineNumber\n        isLineNumberRequired\n        bundleId\n        bundleType\n        bundleSubType\n        processContext\n        categoryId\n        promotion\n        offerIds\n        availability {\n          available\n          offerCategory\n          status\n        }\n        items {\n          action\n          itemId\n          productOfferingId\n          title\n          creditItemDescriptions\n          description\n          priceItemName\n          priceItemDescriptions\n          quantity\n          removable\n          editable\n          dealText\n          imageUrl\n          totalPrice\n          balanceManagement\n          contractTerm {\n            name\n            value\n            unit\n            ifpOfferId\n          }\n          preOrderable\n          prices {\n            billingFrequency\n            frequencyType\n            basePrice {\n              value\n              taxExclusiveValue\n            }\n            effectivePrice {\n              value\n              taxExclusiveValue\n            }\n            discount {\n              discountId\n              type\n              value\n              discountType\n              taxExclusiveValue\n              discountText\n              discountAppliedValue\n            }\n          }\n          offerId\n          categories\n          dataLayerCategory\n          isIncluded\n          shouldHide\n          promotion\n        }\n      }\n      auth {\n        isAuthenticated\n        isGuest\n      }\n      summaries {\n        billingFrequency\n        frequencyType\n        subtotal\n        total\n        taxExclusiveSubtotal\n        discount\n        taxExclusiveDiscount\n        taxExclusiveTotal\n        gst\n      }\n      mpdDiscountPercentage\n      productOfferImages(channel: $channel) {\n        offerId\n        url\n        type\n      }\n      id\n    }\n    isAddonsJourneyEligible(input: $input)\n    isGiftWithPurchaseJourneyEligible(input: $input)\n    affectedBundle {\n      bundleId\n      items {\n        itemId\n        promotion\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "12ebbfc182dc5ca7c7b2a4e80fea9685";

export default node;
